import { render } from "./myCoupons.vue?vue&type=template&id=62b787e9&scoped=true"
import script from "./myCoupons.vue?vue&type=script&lang=js"
export * from "./myCoupons.vue?vue&type=script&lang=js"

import "./myCoupons.vue?vue&type=style&index=0&id=62b787e9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b787e9"]])

export default __exports__